import api from "Common/Client/Interceptor";

export const getAdminPaymentLedgerList = async (params = {}) => {
  try {
    const response = await api.get("/indv/LearnerPaymentLedger/Get-List", {
      params: {
        pageNumber: params.pageNumber || 1,
        pageSize: params.pageSize || 10,
        orderByLatest: params.orderByLatest || true,
        ...params
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching admin payment ledger:", error);
    throw error;
  }
};

export const getPaymentLedgerById = async (id) => {
  try {
    const response = await api.get(`/indv/LearnerPaymentLedger/Get-By-Id/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching payment ledger by ID:", error);
    throw error;
  }
};

// Get payment statistics (if you have a separate endpoint)
export const getPaymentStatistics = async () => {
  try {
    // If you have a statistics endpoint
    const response = await api.get("/indv/LearnerPaymentLedger/Get-Statistics");
    return response.data;
  } catch (error) {
    console.error("Error fetching payment statistics:", error);
    // Return default stats if endpoint doesn't exist
    return {
      totalRevenue: 0,
      totalTransactions: 0,
      successfulPayments: 0,
      pendingPayments: 0,
      averageTransaction: 0
    };
  }
};